export default "__VITE_ASSET__DCzy_$Pt__"